import {
	GETWALLETOWNERIDNAMELIST_SUCCESS,
	GETWALLETOWNERIDNAMELIST_FAILED,
	RESET_GETWALLETOWNERIDNAMELIST,
	LOADING_GETWALLETOWNERIDNAMELIST,
	NETWORK_ERROR_GETWALLETOWNERIDNAMELIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetWalletOwnerIdAndNameList = () => {
	return { type: RESET_GETWALLETOWNERIDNAMELIST };
};

const getWalletOwnerIdAndNameList =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_GETWALLETOWNERIDNAMELIST });
		await adminServices
			.post("getWalletOwnerIdAndNameList", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(getWalletOwnerIdAndNameListsuccess(res.data));
						break;
					default:
						dispatch(getWalletOwnerIdAndNameListFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_GETWALLETOWNERIDNAMELIST,
					payload: err
				});
			});
	};
function getWalletOwnerIdAndNameListsuccess(data) {
	return {
		type: GETWALLETOWNERIDNAMELIST_SUCCESS,
		payload: data
	};
}
function getWalletOwnerIdAndNameListFailed(data) {
	return {
		type: GETWALLETOWNERIDNAMELIST_FAILED,
		payload: data
	};
}

export { resetGetWalletOwnerIdAndNameList, getWalletOwnerIdAndNameList };
